import { MutationTree } from 'vuex'
import { PodcastState } from '../types'
import setPodcast from './setPodcast'
const mutations: MutationTree<PodcastState> = {
  setPodcast,
}

export default mutations
